"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var request_item_1 = __importDefault(require("~/components/users/estimates/requests/unread_request/request_list/request_item"));
var RequestItemList = function (props) { return (react_1.default.createElement("div", { className: "unreadRequestWindow-Body" }, props.requestItems.map(function (item) { return (react_1.default.createElement(request_item_1.default, { key: item.request.id, requestItem: item, onClickRequestItemBox: props.onClickRequestItemBox })); }))); };
exports.default = RequestItemList;
